"use client";

import { motion, useReducedMotion } from "framer-motion";
import * as React from "react";

import { cookingIdleConfig } from "@/lib/animations";

interface CookingUtensilsProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CookingUtensils({ size = 40, className, ...props }: CookingUtensilsProps) {
  const prefersReduced = useReducedMotion();
  const pivot = "12px 12px";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      focusable={false}
      {...props}
    >
      <motion.g
        animate={prefersReduced ? undefined : cookingIdleConfig.fork.animate}
        transition={cookingIdleConfig.fork.transition}
        style={{ transformOrigin: pivot }}
      >
        <path d="m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8" />
        <path d="m19 5-7 7" />
        <path d="m2.1 21.8 6.4-6.3" />
      </motion.g>
      <motion.g
        animate={prefersReduced ? undefined : cookingIdleConfig.knife.animate}
        transition={cookingIdleConfig.knife.transition}
        style={{ transformOrigin: pivot }}
      >
        <path d="M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7" />
      </motion.g>
    </svg>
  );
}
